import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { ApplicationEnum } from "~/@types/enums";
import { getDockShellRoute } from "~/components/dock/dockShellRoutes";
import { FeatureFlagName } from "~/gql/graphqlBase.generated";
import parseForecastConfig from "~/helpers/parseForecastConfig";
import { useAppSelector } from "~/hooks/reduxHooks";
import useFeatureFlag from "~/hooks/useFeatureFlag";

const useIsDockShellRoute = (): boolean => {
	const location = useLocation();
	const isWideScreen = useAppSelector((state) => state.layout.isWideScreen);
	const { config, isEnabled } = useFeatureFlag(FeatureFlagName.Forecast);
	const { showScopingUI } = useMemo(() => parseForecastConfig(config), [config]);
	const isForecastEnabled = isEnabled && showScopingUI;

	if (!isWideScreen) {
		return false;
	}

	const route = getDockShellRoute(location.pathname);
	if (!route) {
		return false;
	}

	if (route.module === ApplicationEnum.FORECAST && !isForecastEnabled) {
		return false;
	}

	return true;
};

export default useIsDockShellRoute;
